"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Slide_1 = __importDefault(require("@material-ui/core/Slide"));
var Slide = function (_a) {
    var children = _a.children, direction = _a.direction, timeout = _a.timeout;
    return (react_1.default.createElement(Slide_1.default, { direction: direction, timeout: timeout }, children));
};
exports.default = Slide;
